export const environment = {
  production: true,
  i18nPrefix: '',
  defaultConfigFile: 'assets/default/config/config.json',
  domain: undefined
};
